<template>
  <div class="catalog-abiturientam">
    <catalog-abiturientam-banner />

    <catalog-abiturientam-cards
      class="catalog-abiturientam__cards"
    />

    <school-new-form />

    <school-new-breadcrumbs
      :breadcrumbs="breadcrumbs"
    />
  </div>
</template>

<script>
import HeadMixin from '~/mixins/HeadMixin';

import CatalogAbiturientamBanner from '../../../components/v2/catalog-abiturientam/CatalogAbiturientamBanner.vue';
import CatalogAbiturientamCards from '../../../components/v2/catalog-abiturientam/CatalogAbiturientamCards.vue';
import SchoolNewForm from '../../../components/v2/school-new/SchoolNewForm.vue';
import SchoolNewBreadcrumbs from '../../../components/v2/school-new/SchoolNewBreadcrumbs.vue';

export default {
  name: 'CatalogAbiturientamPage',
  components: {
    CatalogAbiturientamBanner,
    CatalogAbiturientamCards,
    SchoolNewForm,
    SchoolNewBreadcrumbs,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    // для head
    title: 'Поступление в вуз и колледж: программы для абитуриентов | Школьный университет Синергия',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Поможем начать путь к высшему образованию. Подберем подходящую образовательную программу: колледж, вуз, второе высшее, двойной диплом или образование за рубежом',
    image: '/v2/catalog-abiturientam/share-image.jpg',

    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'каталог', to: '/catalog/repetitor' },
      { text: 'абитуриентам', to: '/catalog/abiturientam' },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.catalog-abiturientam {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 24);
    gap: calc(var(--scale) * 80);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  &__cards {
    margin-top: calc(var(--scale) * -68);

    @include media-down($size-tablet) {
      margin-top: 0;
    }

    @include media-down($size-mobile) {
      margin-top: calc(var(--scale) * -40);
    }
  }
}

::v-deep(.main-title h2),
::v-deep(.courses-title) {
  font-weight: 500;
  font-size: 5.375rem;
  line-height: 110%;
  letter-spacing: -0.04em;
  color: #02120F;
  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    font-size: 4rem;
  }

  span {
    color: #A7ABAC;
  }
}
</style>
